
import React from 'react';
import Header from '@/components/layout/Header';
import { Coins } from 'lucide-react';
import RoyaltyDistribution from '@/components/royalties/RoyaltyDistribution';
import RoyaltyTracking from '@/components/royalties/RoyaltyTracking';
import UnclaimedRoyalties from '@/components/royalties/UnclaimedRoyalties';

const Royalties: React.FC = () => {
  return (
    <div className="min-h-screen bg-background bg-gradient-to-b from-background to-background/80">
      <Header />
      
      <main className="pt-24 pb-28 px-4 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8 animate-fade-in">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold flex items-center gap-3 bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">
              <Coins className="h-10 w-10 text-blue-500" />
              Royalties
            </h1>
            <p className="text-muted-foreground text-lg">Track and manage your music royalties and splits</p>
          </div>
        </div>
        
        <div className="space-y-8 animate-slide-up">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/20 to-purple-600/20 blur-2xl -z-10 rounded-3xl"></div>
            <RoyaltyDistribution />
          </div>
          
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-emerald-500/20 to-blue-500/20 blur-2xl -z-10 rounded-3xl"></div>
            <RoyaltyTracking />
          </div>
          
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-orange-400/20 to-pink-500/20 blur-2xl -z-10 rounded-3xl"></div>
            <UnclaimedRoyalties />
          </div>
        </div>
      </main>
    </div>
  );
};

export default Royalties;
